import { Button, Col, Divider, Row } from 'antd';
import React from 'react';
import { CamposFormularioCadastroProduto } from './campos-formulario-cadastro-produto';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSave} from '@fortawesome/pro-duotone-svg-icons';

const FormularioCadastroProdutosRow = (props) => {
    const {onSalvar, salvando} = props;
    return <Row>
        <Col span={24}>
            <CamposFormularioCadastroProduto {...props}></CamposFormularioCadastroProduto>
        </Col>

        <Divider></Divider>
        
        <Col span={24} style={{'textAlign': "right"}}>
                <Button size="large" type='primary'
                    loading={salvando}
                    onClick={onSalvar} 
                    icon={<FontAwesomeIcon icon={faSave} />}
                >&nbsp;Salvar</Button>
        </Col>

    </Row>
}

export {FormularioCadastroProdutosRow}